// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HmYrs","selected":"styles_selected__25meX"};